import { Level } from '../types/level'

export const scoreboardConstants = {
	similarHouseholds: {
		gradientWidths: ['70%', '82%', '92%'] as const,
		gradientClasses: [
			'bg-[linear-gradient(90deg,rgba(217,217,217,0.3)_0%,rgba(208,206,242,0.3)_48.5%,rgba(189,188,210,0.3)_100%)]',
			'bg-[linear-gradient(90deg,#6EE7B7_0%,#BCFFCB_54.5%,#34D399_100%)]',
			'bg-[linear-gradient(90deg,rgba(220,184,127,0.3)_0%,rgba(255,229,188,0.3)_47%,rgba(244,201,131,0.3)_100%)]',
		] as const,
	},
	swiper: {
		slidesPerView: 1,
		spaceBetween: 16,
		speed: 300,
		touchRatio: 1,
		touchAngle: 45,
	},
	card: {
		aspectRatio: 'aspect-[2.2/1]' as const,
		borderStyle: 'border border-[#c4c4c4] dark:border-brand-primary-200-dark' as const,
		roundedStyle: 'rounded-2xl' as const,
	},
} as const

export const timePeriods = {
	last: 'last' as const,
	allTime: 'all-time' as const,
} as const

export type TimePeriod = (typeof timePeriods)[keyof typeof timePeriods]

export const similarHouseholdsGradients = [
	{
		className: `
			bg-[linear-gradient(90deg,rgba(217,217,217,0.3)_0%,rgba(208,206,242,0.3)_48.5%,rgba(189,188,210,0.3)_100%)]
			dark:bg-[linear-gradient(90deg,#CBD5E1_0%,#E2E8F0_48.5%,#CBD5E1_100%)]
		`,
		width: 'w-[70%]',
	},
	{
		className: `
			bg-[linear-gradient(90deg,#6EE7B7_0%,#BCFFCB_54.5%,#34D399_100%)]
			dark:bg-[linear-gradient(90deg,#34D399_0%,#6EE7B7_54.5%,#34D399_100%)]
		`,
		width: 'w-[82%]',
	},
	{
		className: `
			bg-[linear-gradient(90deg,rgba(220,184,127,0.3)_0%,rgba(255,229,188,0.3)_47%,rgba(244,201,131,0.3)_100%)]
			dark:bg-[linear-gradient(90deg,#ddc590_0%,#f0e0bf_47%,#ddc590_100%)]
		`,
		width: 'w-[92%]',
	},
] as const

export type SimilarHouseholdGradient = (typeof similarHouseholdsGradients)[number]

export const mockHouseholdsData = [
	{ value: 0, label: '' },
	{ value: 0, label: '' },
	{ value: 0, label: '' },
] as const

export const defaultScoreboardData = {
	totalPoints: 0,
	totalSavings: 0,
	lastPoints: 0,
	lastSavings: 0,
	lastLevel: 'silver' as Level,
	lastPercentage: 0,
	bestSimilarHouseholds: {
		points: mockHouseholdsData,
		savings: mockHouseholdsData,
	},
	isLoading: false,
	error: null,
} as const
